import "./Title.css";

type Props = { text: string; className?: string };

export default function Title({ text, className = "" }: Props) {
  return (
    <>
      <div className={"title text-5xl mobile " + className}>
        <p className="text ">{text}</p>
      </div>
      <div className={"title text-5xl desktop " + className}>
        <p className="text">{text}</p>
      </div>
    </>
  );
}
